import styled from 'styled-components/macro';
const StyledLabel = styled.label`
  font-family: 'Inter';
`;
const CardHeadingLabel = styled(StyledLabel)`
  font-size: 18px;
  font-weight: 600;
  color: ${p => p.theme.hrmsCardHeadingLabelColor};
  margin: 5px 0;
  text-transform: capitalize;
  display: block;
  line-height: 28px;
`;
const CardHeadingSubLabel = styled(StyledLabel)`
  font-size: 14px;
  font-weight: 400;
  color: ${p => p.theme.hrmsCardHeadingSubLabelColor};
  margin: 5px 0;
  text-transform: capitalize;
  display: block;
  line-height: 20px;
`;
const NoDataFoundLabel = styled(StyledLabel)`
  font-size: 20px;
  font-weight: 400;
  color: ${p => p.theme.hrmsNoDataFoundLabel};
  margin: 5px 0 12px 0;
  text-transform: capitalize;
  display: block;
  line-height: 20px;
`;

const NoDataFoundSubLabel = styled(StyledLabel)`
  font-size: 16px;
  font-weight: 400;
  color: ${p => p.theme.hrmsNoDataFoundSubLabel};
  margin: 5px 0;
  display: block;
  line-height: 24px;
`;
const UserCardContentLabel = styled.label`
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 400;
  color: ${p => p.theme.hrmsuserCardContentLabelColor};
  display: block;
`;
const NavProfileNameLabel = styled(StyledLabel)`
  font-size: 14px;
  font-weight: 600;
  color: ${p => p.theme.hrmsNavProfileNameLabel};
  margin: 5px 0 0 0;
  display: block;
  line-height: 24px;
`;
const NavProfileNameSubLabel = styled(StyledLabel)`
  font-size: 14px;
  font-weight: 500;
  color: ${p => p.theme.hrmsNavProfileNameSubLabel};
  margin: 0 0 5px 0;
  display: block;
  line-height: 24px;
`;
const NotificationHeadLabel = styled(StyledLabel)`
  font-weight: 600;
  font-size: 18px;
  color: ${p => p.theme.hrmsNavProfileNameLabel};
  margin: 0 0 5px 0;
  line-height: 28px;
`;
const NotificationInnerHeadLabel = styled(StyledLabel)`
  font-weight: 600;
  font-size: 14px;
  color: ${p => p.theme.hrmsNotificationInnerHeadLabel};
  margin: 0 0 5px 0;
  line-height: 8px;
`;
const NotificationInnerContentLabel = styled(StyledLabel)`
  font-weight: 400;
  font-size: 14px;
  color: ${p => p.theme.hrmsNotificationInnerContentLabel};
  margin: 0 0 5px 0;
  line-height: 8px;
`;
const DateTimeLabel = styled(StyledLabel)`
  font-weight: 400;
  font-size: 14px;
  color: ${p => p.theme.hrmsdateTimeLabelColor};
  font-size: 12px;
`;
const StatusLabel = styled(StyledLabel)`
  font-weight: 500;
  font-size: 14px;
`;
const PageMainLabel = styled(StyledLabel)`
  font-weight: 600;
  font-size: 25px;
  color: ${p => p.theme.hrmsPageMainLabelText};
  margin: 0 0 5px 0;
  line-height: 38px;
`;
const PageMainSubLabel = styled(StyledLabel)`
  display: block;
  font-weight: 400;
  font-size: 16px;
  color: ${p => p.theme.hrmsPageMainSubLabelText};
  margin: 0 0 5px 0;
  line-height: 24px;
`;
const InnerPageMainLabel = styled(StyledLabel)`
  font-weight: 600;
  font-size: 20px;
  color: ${p => p.theme.hrmsPageMainLabelText};
  margin: 0 0 0 0;
  line-height: 24px;
`;
const HrmsFilterBlurredLabel = styled(StyledLabel)`
  font-family: 'Inter';
  font-size: 14px;
  margin-top: auto;
  margin-bottom: auto;
  color: ${p => p.theme.hrmsBluredTextBtnText} !important;
  font-weight: 500;
`;

export {
  CardHeadingLabel,
  CardHeadingSubLabel,
  NoDataFoundLabel,
  NoDataFoundSubLabel,
  UserCardContentLabel,
  NavProfileNameLabel,
  NavProfileNameSubLabel,
  NotificationHeadLabel,
  NotificationInnerHeadLabel,
  NotificationInnerContentLabel,
  DateTimeLabel,
  StatusLabel,
  PageMainLabel,
  PageMainSubLabel,
  InnerPageMainLabel,
  HrmsFilterBlurredLabel,
};
